import React, { useEffect, useState } from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from '../components/ScrollAnimation';
import { statsAPI } from '../utils/api';

const Home = () => {
  const [stats, setStats] = useState({
    totalContacts: 0,
    totalSubscribers: 0,
    totalViews: 0,
    projects: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await statsAPI.get();
        setStats(data);
      } catch (err) {
        console.error('Failed to fetch stats:', err);
      }
    };
    fetchStats();
  }, []);

  return (
    <div className="page-container">
      <h1 className="page-title">Welcome to AI CoE</h1>
      <div className="page-content">
        <FadeIn>
          <div className="hero-section">
            <h2>Advancing AI Innovation</h2>
            <p>
              The AI Center of Excellence is dedicated to pioneering cutting-edge artificial 
              intelligence research and developing transformative solutions for the future.
            </p>
          </div>
        </FadeIn>

        <StaggerContainer staggerDelay={0.15}>
          <div className="stats-grid">
            <StaggerItem>
              <div className="stat-card">
                <div className="stat-number">{stats.projects}</div>
                <div className="stat-label">Projects</div>
              </div>
            </StaggerItem>
            <StaggerItem>
              <div className="stat-card">
                <div className="stat-number">{stats.totalViews}</div>
                <div className="stat-label">Total Views</div>
              </div>
            </StaggerItem>
            <StaggerItem>
              <div className="stat-card">
                <div className="stat-number">{stats.totalSubscribers}</div>
                <div className="stat-label">Subscribers</div>
              </div>
            </StaggerItem>
            <StaggerItem>
              <div className="stat-card">
                <div className="stat-number">{stats.totalContacts}</div>
                <div className="stat-label">Contacts</div>
              </div>
            </StaggerItem>
          </div>
        </StaggerContainer>

        <FadeIn direction="up" delay={0.3}>
          <div className="section">
            <h2>Our Mission</h2>
            <p>
              To advance the field of artificial intelligence through groundbreaking research, 
              innovative applications, and collaborative partnerships. We strive to create AI 
              solutions that are ethical, accessible, and transformative.
            </p>
          </div>
        </FadeIn>

        <FadeIn direction="up" delay={0.4}>
          <div className="section">
            <h2>Focus Areas</h2>
            <ul>
              <li>Machine Learning & Deep Learning</li>
              <li>Natural Language Processing</li>
              <li>Computer Vision</li>
              <li>Robotics & Autonomous Systems</li>
              <li>AI Ethics & Responsible AI</li>
              <li>Quantum Machine Learning</li>
            </ul>
          </div>
        </FadeIn>

        <FadeIn direction="up" delay={0.5}>
          <div className="section">
            <h2>Why Choose AI CoE?</h2>
            <StaggerContainer staggerDelay={0.2}>
              <div className="card-grid">
                <StaggerItem>
                  <div className="card">
                    <h3>🎓 Expert Team</h3>
                    <p>World-class researchers and engineers with decades of combined experience</p>
                  </div>
                </StaggerItem>
                <StaggerItem>
                  <div className="card">
                    <h3>🚀 Innovation</h3>
                    <p>Cutting-edge research pushing the boundaries of what's possible with AI</p>
                  </div>
                </StaggerItem>
                <StaggerItem>
                  <div className="card">
                    <h3>🤝 Collaboration</h3>
                    <p>Strong partnerships with leading universities and industry leaders</p>
                  </div>
                </StaggerItem>
              </div>
            </StaggerContainer>
          </div>
        </FadeIn>
      </div>
    </div>
  );
};

export default Home;
